import * as React from 'react';
import { Text, Button, UnorderedList, ListItem } from '@chakra-ui/react';
import { Modal, Link, RequirementsSummary, RequirementsRemedy } from 'shared-components';
import UploadIntro from '../../../../atoms/upload-intro';

interface IProps {
  onClose: () => void;
  onContinue: () => void;
  isBankAccepted: boolean;
  bankName?: string;
}

const InvalidFundingModal: React.FC<IProps> = (props: IProps) => {
  return (
    <Modal
      id={'invalidFundingSource'}
      show={true}
      title={'Invalid Funding Source'}
      onClose={props.onClose}
      footer={
        <Button onClick={props.onContinue} variant="solid" size="lg">
          Add to/Change Finance Plan
        </Button>
      }
    >
      <UploadIntro uploadWarning>
        <b>Your funding source may not be valid.</b>
      </UploadIntro>

      {props.isBankAccepted ? (
        <>
          <Text>
            In order to prove you have personal funds to cover your course fees and/or living costs you must be able to
            show the required amount in one of the following accounts:
          </Text>

          <RequirementsSummary title="Bank account be either:">
            <UnorderedList mb={4}>
              <ListItem>Your own personal account</ListItem>
              <ListItem>Your parent's account</ListItem>
              <ListItem>Your legal guardian's account</ListItem>
              <ListItem>
                Joint account with partner/spouse
                <br />
                (If your name appears on the bank statement you can treat the account as your own and select “myself” as
                a funding source)
              </ListItem>
            </UnorderedList>

            <Text mb={0}>Accounts held by other family or friends cannot be used.</Text>
          </RequirementsSummary>
        </>
      ) : (
        <>
          <Text>
            <b>{props.bankName || 'Your bank'}</b> is listed by the UK Government as a financial institution that does
            not satisfactorily verify financial statements.
          </Text>

          <Text>This list of banks is viewable here:</Text>

          <Text>
            <Link
              href={
                'https://www.gov.uk/guidance/immigration-rules/immigration-rules-appendix-p-lists-of-financial-institutions'
              }
              isExternal
            >
              Appendix P: lists of financial institutions
            </Link>
          </Text>
        </>
      )}

      <RequirementsRemedy>
        {props.isBankAccepted ? (
          <Text>
            Return to the funding planning/setup page to delete the invalid funding source and add the correct source of
            funds if an error was made.
          </Text>
        ) : (
          <>
            <Text>Check the introduction section of the above link for more information.</Text>

            <Text>
              If you selected this bank in error, you can use the link below to return to the funding setup page, delete
              the invalid funding source and add the correct source of funds.
            </Text>
          </>
        )}
      </RequirementsRemedy>
    </Modal>
  );
};

export default InvalidFundingModal;
